export const bikeBrands = [
  "Hero MotoCorp",
  "Bajaj Auto",
  "TVS Motor",
  "Royal Enfield",
  "Honda",
  "Yamaha",
  "Suzuki",
  "Kawasaki",
  "KTM",
  "Husqvarna",
  "BMW Motorrad",
  "Triumph",
  "Ducati",
  "Aprilia",
  "Benelli",
  "Harley-Davidson",
  "Revolt Motors",
  "Ultraviolette",
  "Tork Motors",
  "Ather Energy",
  "Ola Electric",
  "Simple Energy"
];
